import { createClient } from '@supabase/supabase-js';
import { ACTIVE_CELL } from './cells';

/**
 * Sign-in, the authenticator-app factor and passkeys only. Every data call goes to
 * admin-api through src/lib/api.ts; the portal never queries a table or
 * calls an RPC (decision 0007).
 */
const { url, key } = ACTIVE_CELL;

export const supabaseConfigured = Boolean(url && key);

// The cell comes from the list at run time, so a fallback here survives into
// the bundle: the local stack's address only in development, never in a build
// (build:prod refuses a bundle holding a local address).
const fallbackUrl = import.meta.env.DEV
  ? 'http://127.0.0.1:54321'
  : 'https://backend-not-configured.invalid';
const backendUrl = url ?? fallbackUrl;

export const supabase = createClient(
  backendUrl,
  key ?? 'missing-publishable-key',
  {
    auth: {
      // Passkey sign-in is experimental in supabase-js and must be opted into.
      experimental: { passkey: true },
      persistSession: true,
      autoRefreshToken: true,
      detectSessionInUrl: true,
      // One session store per cell: a session is never reused across cells.
      storageKey: ACTIVE_CELL.storageKey,
    },
  },
);

// VITE_ADMIN_API_URL points the portal at an admin-api served some other way
// (for example `deno serve` on a machine whose local edge runtime cannot fetch
// its imports). Unset, it is the project's own functions URL.
const adminApiUrl = ACTIVE_CELL.adminApiUrl;

const functionsUrl = `${backendUrl.replace(/\/$/, '')}/functions/v1`;
export const adminApiEndpoint = adminApiUrl ?? `${functionsUrl}/admin-api`;
export const publishableKey = key ?? '';
